import React, { useEffect, useState } from 'react';

export default function AppUpdatePrompt() {
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    const handler = (event) => {
      setRegistration(event.detail);
    };

    window.addEventListener('appUpdateAvailable', handler);

    return () => {
      window.removeEventListener('appUpdateAvailable', handler);
    };
  }, []);

  const reload = () => {
    if (!registration?.waiting) {
      window.location.reload();
      return;
    }

    registration.waiting.postMessage({ type: 'SKIP_WAITING' });

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      window.location.reload();
    });
  };

  if (!registration) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      backgroundColor: '#fff',
      padding: '16px',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      borderRadius: '8px',
      zIndex: 9999,
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      border: '1px solid #eaeaea'
    }}>
      <p style={{ margin: 0, fontWeight: 500 }}>A new version is available.</p>
      
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
        <button 
          onClick={() => setRegistration(null)}
          style={{ padding: '6px 12px', border: '1px solid #ccc', borderRadius: '4px', background: '#fff', cursor: 'pointer' }}
        >
          Later
        </button>
        <button 
          onClick={reload}
          style={{ padding: '6px 12px', border: 'none', borderRadius: '4px', background: '#1890ff', color: '#fff', cursor: 'pointer' }}
        >
          Reload
        </button>
      </div>
    </div>
  );
}
